import { ReactNode, useCallback, useMemo } from 'react';
import { useSlideLayoutSafe } from '../../slide-layout';
import {
  RoutineLabelPickerContext,
  RoutineLabelPickerRequest,
} from './routineLabelPickerContext';

type Props = {
  onRequestChange: (request: RoutineLabelPickerRequest) => void;
  children: ReactNode;
};

export const RoutineLabelPickerProvider = ({
  onRequestChange,
  children,
}: Props) => {
  const slideLayout = useSlideLayoutSafe();

  const openLabelPicker = useCallback(
    (request: RoutineLabelPickerRequest) => {
      onRequestChange(request);
      slideLayout?.toggleThirdPanel();
    },
    [onRequestChange, slideLayout]
  );

  const closeLabelPicker = useCallback(() => {
    slideLayout?.toggleThirdPanel();
  }, [slideLayout]);

  const value = useMemo(
    () => ({ openLabelPicker, closeLabelPicker }),
    [openLabelPicker, closeLabelPicker]
  );

  return (
    <RoutineLabelPickerContext.Provider value={value}>
      {children}
    </RoutineLabelPickerContext.Provider>
  );
};
